import type {
  MaintenanceTaskInsert,
  MaintenanceTaskUpdate,
  MaintenanceTaskWithSteps,
} from '@markku/types'
import { createCrudHooks } from './base'

export const maintenanceTaskHooks = createCrudHooks<
  MaintenanceTaskWithSteps,
  MaintenanceTaskWithSteps,
  MaintenanceTaskInsert,
  MaintenanceTaskUpdate
>('maintenanceTask')
